export default function ToggleField({ label, value, onChange, disabled = false, 'data-testid': dataTestId }) {
  return (
    <div className={`flex items-center justify-between ${disabled ? 'opacity-50' : ''}`}>
      <span className="text-xs text-slate-600 dark:text-gray-300">{label}</span>
      <button
        type="button"
        disabled={disabled}
        data-testid={dataTestId}
        aria-pressed={value}
        onClick={() => !disabled && onChange(!value)}
        className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${
          value ? 'bg-blue-600' : 'bg-slate-300 dark:bg-gray-600'
        } ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
      >
        <span
          className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform ${
            value ? 'translate-x-5' : 'translate-x-1'
          }`}
        />
      </button>
    </div>
  )
}
